module.exports = __webpack_public_path__ + "static/media/EVA_Logo_2022_February_for_light_background.a2ad173a.svg";